export const appConfig = {
     baseAPIURL: 'https://api.stg.claimlinq.com.au'
}
appConfig.APILogin = appConfig.baseAPIURL + '/ir/auth/login';